<template>
  <el-main :style="{height:height+'px'}">
    <div class="Scroll_content" :style="{height:height+'px'}">
      <div>
        <div class="simkeropl">{{$t('information.Profile')}}</div>
            <div class="yinweimm"><img class="img_kplin" style="margin-right:5px;" src="../../assets/Profile.svg" alt=""> {{$t('information.Parent_Full_Time')}}</div>
            <div class="hanzi mlk">{{userInfo.name == ""||!userInfo.name ? '-' : userInfo.name}}</div>
            <div class="yinweimm"><img class="img_kplin" src="../../assets/Vector(1).svg" alt="">{{$t('information.Phone_no')}}</div>
            <div class="hanzi mlk">+{{userInfo.country_code}} {{userInfo.mobile}}</div>
            <div class="yinweimm"><img class="img_kplin" src="../../assets/ddIconColor.svg" alt="">{{$t('information.Location')}}</div>
            <div class="hanzi mlk">{{userInfo.user_country == "" ? '-' : userInfo.user_country}}</div>
            <div class="yinweimm"><img class="img_kplin" src="../../assets/yxIconColor.svg" alt="">{{$t('information.Email')}}</div>
            <div class="hanzi mlk">{{userInfo.email}}
              <img @click="chooseEdit" src="../../assets/Strokexxx.svg" alt=""></div>



            <div class="henaa"></div>

            <div class="yinweimm"><img  style="width:20px;margin-right:10px" src="../../assets/user_zn.png" alt="">{{$t('information.Preferred_language')}} </div>
            <div class="hanzi mlk">{{lang}}
              <img  @click="chooselang" src="../../assets/Strokexxx.svg" alt="">
            </div>

            <div class="insewre_bom">
              <div class="ziti">{{$t('information.Password')}}</div>
              <div class="anniu" @click="Jump">{{$t('information.Change')}}</div>
            </div>


        <div class="dian mgb"></div>
      </div>
    </div>
    <div v-if="dialogFormVisible" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title center">
            <b>{{$t('myChild.editProfile')}}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseEdit">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p>{{$t('information.Email')}}</p>
              <el-input v-model="email" autocomplete="off" maxlength="50"></el-input>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small el-button--primary" @click="toEditEmail">
            <span>{{$t('main.send')}}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 修改语言 -->
     <div v-if="userlang" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title center">
            <b>{{$t('information.editProfile')}}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooselang">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p>{{$t('information.Preferred_language')}}</p>
              <div>
                <el-select v-model="lang_new" placeholder="请选择">
                  <el-option label="English" value="en"> English </el-option>
                  <el-option label="中文（简体）" value="zh_CN"> 中文（简体） </el-option>
                  
               </el-select>
              </div>
              

            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small el-button--primary" @click="language_xg">
            <span>{{$t('main.send')}}</span>
          </button>
        </div>
      </div>
    </div>

  </el-main>
  
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from '../views/header'
  import IndexFooter from '../views/footer'
  import MyScheduled from '../views/scheduled'
  import MyCourse from '../views/course'
  import PastLesson from '../views/lesson'

  //引入header组件
  import Header from '../header/header'

  export default {
    inject:['reload'],
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header
    },
    // props:['balanceData'],
    data () {
      return {
          height:100,
          userInfo:[],
          dialogFormVisible:false,
          email:'',//新邮箱
          userlang:false,
          lang_new:'',
          
          
      }
      
    },
    created () {
      let height = document.body.offsetHeight-123;
      this.height = height;
            if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.get_usInfo();
    },
    methods: {
      /**
       * 获取登录用户信息
       */
          /**
     * 获取个人信息
     */
    // get_user(){
    //   let time_zone = this.utils.getTimeZoneCity()
    //   this.$http.get('/api/intercomUser?time_zone='+ time_zone).then((res) => {
    //     if (res.data.code == 200) {
    //       this.user_data = res.data.data;
    //     } else {
    //       this.$message({
    //         message: res.data.msg,
    //         type: 'warning'
    //       })
    //     }
    //   }).catch((error) => {
    //     console.log(error) // 请求失败返回的数据
    //   })
    // },
      get_usInfo () {
        this.$http.get('/api/user/profile').then((res) => {
          if (res.data.code == 200) {
            this.userInfo = res.data.data
            setStore(keys.userProfile, res.data.data)
            this.lang_new = this.userInfo.language?this.userInfo.language:(navigator.language&&navigator.language.toLowerCase().includes('zh-cn')?'zh_CN':navigator.language)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 跳转到设置密码模块
       */
      Jump:function(){
        this.$http.post('/api/judePasswordIshad').then((res) => {
          if (res.data.code == 200) { // 设置过密码
            this.$message({
              message: res.data.data,
              type: 'success'
            })  
            this.$router.push({ path: '/resetPassword?type=1' })
          } else if (res.data.code == 400) { // 未设置过密码
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.$router.push({ path: '/resetPassword?type=0' })
          }
        })
      },
      chooseEdit(){
        this.dialogFormVisible = !this.dialogFormVisible
      },
      chooselang(){
        this.userlang=!this.userlang
      },
      toEditEmail(){
      if(this.email==''){
        this.$message({
          message: this.$t('errorprompt.emailEmpty'),
          type: 'error'
        })
        return false;
      }
        this.$http.post('/api/updateEmail',{
          email:this.email
        }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
            this.chooseEdit();
            this.get_usInfo();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },

      language_xg(){
        // alert(this.b);
       this.$http.post('/api/setUserLanguage', {language: this.lang_new})
       .then((res) => {
        setStore(keys.lang, this.lang_new);
        this.userlang=!this.userlang;
        this.get_usInfo();
        this.$i18n.locale = getStore(keys.lang)
        this.reload();
        }).catch((error) => {
           console.log(error) // 请求失败返回的数据
        })
      }
    },
    mounted () {
        // this.lang=this.userInfo.language?this.userInfo.language:navigator.language
    },
    computed:{
        lang() {
          var ter=this.userInfo.language?this.userInfo.language:(navigator.language&&navigator.language.toLowerCase().includes('zh-cn')?'zh_CN':navigator.language)
          if(ter=='en'){
            return 'English'
          }
          else if(ter=='zh_CN'){
            return '中文（简体）'
          }
         
        },
    },
    watch: {

    },
  }
</script>
<style lang="less" scoped>
 .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
.simkeropl{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 33px;
    color: #000000;
    // text-align: center;
    margin-bottom:48.41px;
    .yinweimm{
      font-family: Sofia Pro;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;
      /* or 100% */
      display: flex;
      align-items: center;
      color: #A5A5A5;
    }
}
    .hanzi{
      font-family: Sofia Pro;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 18px;
      /* identical to box height */
      display: flex;
      align-items: center;
      color: #010103;
      margin-top:23px;
      margin-bottom: 29px;
      img{
        margin-left:10px;
        cursor: pointer;
      }
    }
    .henaa{
      width: 310px;
      height: 0px;
      border: 1px solid #F4F4F4;
      margin-top:29px;
    }
.insewre_bom{
  width:auto;
  height:auto;
  overflow: hidden;
}
.ziti{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 67px;
    color: #000000;
    float: left;
    margin-right: 25px;
}
.anniu{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */
  font-feature-settings: 'tnum' on, 'lnum' on;
  color: #4B69FE;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 10px 0px;
  float: left;
  border: 1px solid #4B69FE;
  cursor: pointer;
  padding: 10px;
  border-radius: 24px;
}
.mlk{
  margin-left:35px;
}
.img_kplin{
  position: relative;
  top: 6px;
  margin-right: 10px;
  width: 20px;
  height: 20px;
}

.el-message-box{
  background: #FAFAFA;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
  border-radius: 14px;
  .el-message-box__header{
    padding: 25px 84px;
    .el-message-box__title{
      margin-bottom:10px;
      font-size: 24px;
    }
    .el-message-box__headerbtn{
      top:25px;
    }
  }
  .el-message-box__content{
    color:#353643;
    padding: 22px 130px 50px;
    .el-message-box__message{
      .el-input{
          width: 100%;
          border-bottom: 1px solid #a5a5a5;
        }
        .errorPass{
          border-bottom: 1px solid #fc424c;
        }
        /deep/ .el-input__inner {
          -moz-appearance: none;
          // width:100%;
          height: 40px;
          border:none;
          background: none;
          font-size: 16px;
          color: #353643;
          font-family: Sofia Pro-Regular;
          letter-spacing: 0px;
          outline: 0;
          padding:0 40px 0 0;
          border-radius: 0;
        }
      >p{
        margin-bottom: 10px;
        font-weight: bold;
      }
    }
  }
  .el-message-box__btns button{
    height: 60px;
    background: #4B69FE;
    border-radius: 50px;
    font-size: 18px;
    color: #FFFFFF;
    border:none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/children/information.vue